import { useEffect, useState } from "react";

import { errorStore } from "@/providers/error-store";

import { AuthLayout } from "@/components/layout/auth-layout";

/**
 * Error Page - Standalone (No API calls, No middleware)
 * Only shown for 503 errors (Service Unavailable)
 * Message is passed via errorStore to avoid URL exposure
 */
const ErrorPage = () => {
  const [message, setMessage] = useState<string>(
    "در حال حاضر امکان برقراری ارتباط با سرور وجود ندارد. لطفاً بعداً مجدداً تلاش کنید."
  );

  useEffect(() => {
    const storedMessage = errorStore.getMessage();
    if (storedMessage) {
      setMessage(storedMessage);
    }
  }, []);

  const handleRetry = () => {
    window.location.href = "/dashboard";
  };

  return (
    <AuthLayout>
      <ErrorContent message={message} onRetry={handleRetry} />
    </AuthLayout>
  );
};

interface ErrorContentProps {
  message: string;
  onRetry: () => void;
}

const ErrorContent = ({ message, onRetry }: ErrorContentProps) => (
  <div className="flex flex-col items-center space-y-6 text-center">
    {/* Error Icon */}
    <div className="flex h-20 w-20 items-center justify-center rounded-full bg-red-100">
      <svg
        className="h-10 w-10 text-red-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        />
      </svg>
    </div>

    {/* Error Code */}
    <div className="text-5xl font-bold text-slate-300">503</div>

    {/* Error Message */}
    <p className="text-base text-slate-600">{message}</p>

    {/* Retry Button */}
    <button
      onClick={onRetry}
      className="inline-flex items-center gap-2 rounded-lg bg-primary px-6 py-3 font-medium text-white transition-colors hover:bg-primary/90"
    >
      <svg
        className="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        />
      </svg>
      تلاش مجدد
    </button>
  </div>
);

export default ErrorPage;
